import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useShop } from '../../../Providers/ShopProvider';

const useGetQueryFromUrl = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { setProductsFilter } = useShop()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        setProductsFilter(prev => ({
            ...prev,
            SearchingQuery: params.get('q')
        }))
    }, [location.search])

    const handleClearQuery = () => {
        navigate(`/Shop`)
    }

    return { handleClearQuery }
}

export default useGetQueryFromUrl